export const VERPACKUNGSEINHEIT_VERPACKUNG = {
  elementId: 1,
  id: 1,
  value: 'Verpackung',
};

export const VERPACKUNGSEINHEIT_LADEMITTEL = {
  elementId: 2,
  id: 2,
  value: 'Lademittel',
};
